interface Support {
	linkText: string
	labelledBy: string
	link?: string
	id?: string
	icon: string
	iconClass?: ClassContext
	target?: '_blank' | '_window'
}

export const supportLines: Support[] = [
	{
		linkText: '+234 903 9810 004',
		link: 'tel:+2349039810004',
		icon: 'phone',
		labelledBy: 'tel'
	},
	{
		linkText: '+234 907 0008 899',
		link: 'tel:+2349070008899',
		icon: 'phone',
		labelledBy: 'tel'
	},

	{
		linkText: '+234 808 8188 002',
		link: 'https://wa.link/xtmmw8',
		icon: 'whatsapp',
		target: '_blank',
		labelledBy: 'tel'
	},
	{
		linkText: 'Chat with us',
		icon: 'mail',
		link: '#',
		id: 'intercom_custom_btn',
		labelledBy: 'customer_support',
		iconClass: 'hover:stroke-white'
	},
	{
		linkText: 'Email',
		link: 'mailto:support@mycovergenius.com',
		id: 'mailto',
		icon: 'mail',
		labelledBy: 'mail'
	}
]
